import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from '@/components/Layout';
import Dashboard from '@/pages/Dashboard';
import Templates from '@/pages/Templates';
import Recipients from '@/pages/Recipients';
import SendCampaign from '@/pages/SendCampaign';
import Campaigns from '@/pages/Campaigns';
import History from '@/pages/History';
import Replies from '@/pages/Replies';
import Automations from '@/pages/Automations';
import Suppressions from '@/pages/Suppressions';
import Settings from '@/pages/Settings';
import Login from '@/pages/Login';
import { Toaster } from '@/components/ui/sonner';
import { getToken, clearToken } from '@/lib/axiosSetup';
import '@/App.css';

/** JWT'nin süresi dolmuş mu? Bozuk token da süresi dolmuş sayılır. */
function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return typeof payload.exp !== 'number' || payload.exp * 1000 <= Date.now();
  } catch {
    return true;
  }
}

// Protected Route Component
// Not: Bu yalnızca kullanıcı deneyimi içindir; gerçek yetkilendirme backend'de
// her /api ucunda JWT doğrulaması ile yapılır.
function ProtectedRoute({ children }) {
  const token = getToken();

  if (!token || isTokenExpired(token)) {
    if (token) clearToken();
    return <Navigate to="/login" replace />;
  }

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Toaster />
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<Login />} />
        
        {/* Protected Routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="templates" element={<Templates />} />
          <Route path="recipients" element={<Recipients />} />
          <Route path="send" element={<SendCampaign />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="replies" element={<Replies />} />
          <Route path="history" element={<History />} />
          <Route path="automations" element={<Automations />} />
          <Route path="suppressions" element={<Suppressions />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;